var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20_1007)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.94739,
    cy: 9.94739,
    r: 9.19739,
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.68 11.2167H9.18589C9.18199 11.0018 9.18004 10.871 9.18004 10.8241C9.18004 10.3397 9.26011 9.94128 9.42027 9.62878C9.58043 9.31628 9.90074 8.96472 10.3812 8.5741C10.8617 8.18347 11.1488 7.92761 11.2425 7.80652C11.3871 7.61511 11.4593 7.40417 11.4593 7.17371C11.4593 6.85339 11.3304 6.57996 11.0726 6.35339C10.8187 6.12292 10.475 6.00769 10.0414 6.00769C9.62339 6.00769 9.27379 6.12683 8.99254 6.36511C8.71129 6.60339 8.51793 6.96667 8.41246 7.45496L6.90074 7.26746C6.94371 6.56824 7.24058 5.97449 7.79136 5.48621C8.34605 4.99792 9.07261 4.75378 9.97105 4.75378C10.9164 4.75378 11.6683 5.00183 12.2269 5.49792C12.7855 5.99011 13.0648 6.56433 13.0648 7.22058C13.0648 7.58386 12.9613 7.92761 12.7543 8.25183C12.5511 8.57605 12.1136 9.01746 11.4418 9.57605C11.0941 9.86511 10.8773 10.0975 10.7914 10.2733C10.7093 10.4491 10.6722 10.7635 10.68 11.2167ZM9.18589 13.4315V11.785H10.8324V13.4315H9.18589Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20_1007"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.a879bc60.svg";
export { ForwardRef as ReactComponent };